import { KEY_NAME } from "./KeyName";

export function HomeDescription(entityName) {
  switch (entityName) {
    case KEY_NAME.FUNDER:
      return "The dashboard service enables funders, institutions, researchers, publishers, and the public to keep track of open access compliance by our publisher members. CHORUS monitors Members and Participant content and audits open access and other criteria. The funder dashboard links below provide both aggregated data and a path to the actual articles. Click on a funder name to access the dashboard.";

    case KEY_NAME.PUBLISHER:
      return "The dashboard service enables funders, institutions, researchers, publishers, and the public to keep track of open access compliance by our publisher members. CHORUS monitors Member and Participant content and audits for open access and other criteria. The publisher dashboard links below provide both aggregated data and a path to the actual articles. Click on publisher name to access dashboard.";
    case KEY_NAME.INSTITUTION:
      return "The dashboard service enables funders, institutions, researchers, publishers, and the public to keep track of open access compliance by our publisher members. CHORUS monitors Member and Participant content and audits for open access and other criteria. The institution dashboard links below provide both aggregated data and a path to the actual articles. Click on institution name to access dashboard.";

    default:
      break;
  }
}

export const allowedEntities = [
  KEY_NAME.FUNDER,
  KEY_NAME.PUBLISHER,
  KEY_NAME.INSTITUTION,
];
